import { create } from 'zustand'
import type { User, Firm } from '@/types'

interface AuthState {
  user: User | null
  firms: Firm[]
  currentFirm: Firm | null
  isAuthenticated: boolean
  isLoading: boolean
  setUser: (user: User | null) => void
  setFirms: (firms: Firm[]) => void
  setCurrentFirm: (firm: Firm | null) => void
  setLoading: (loading: boolean) => void
  login: (access: string, refresh: string) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  firms: [],
  currentFirm: null,
  isAuthenticated: !!localStorage.getItem('access_token'),
  isLoading: true,

  setUser: (user) => set({ user }),
  setFirms: (firms) => set({ firms }),
  setCurrentFirm: (firm) => {
    if (firm) localStorage.setItem('current_firm_id', firm.id)
    set({ currentFirm: firm })
  },
  setLoading: (isLoading) => set({ isLoading }),

  login: (access, refresh) => {
    localStorage.setItem('access_token', access)
    localStorage.setItem('refresh_token', refresh)
    set({ isAuthenticated: true })
  },

  logout: () => {
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('current_firm_id')
    set({ user: null, firms: [], currentFirm: null, isAuthenticated: false, isLoading: false })
  },
}))
